import { TeamPlan, TeamPlanUsageCapType } from "@alch/dx-entities";
import { trpc } from "@util/trpc/trpcClient";
import usePlanOverride from "./usePlanOverride";

export default function usePlanPreference() {
  const {
    tier: tierOverride,
    term: termOverride,
    usageCapType: usageCapTypeOverride,
  } = usePlanOverride();

  return trpc.billing.getFutureTeamPlan.useQuery(undefined, {
    refetchOnWindowFocus: false,
    select: (plan): TeamPlan => {
      return {
        ...plan,
        tier: tierOverride ?? plan.tier,
        term: termOverride ?? plan.term,
        autoScale:
          usageCapTypeOverride != null
            ? usageCapTypeOverride === TeamPlanUsageCapType.AutoScale
            : plan.autoScale,
      };
    },
  });
}
